import { Table, Popover, Modal } from 'antd';
import { ColumnsType, Group } from '@/components/_common';
import { useNumberInutilizationList } from '@/core/domain/invoice/numberInutilization/numberInutilization.hooks';
import {
  NumberInutilization,
  NumberInutilizationRequest,
} from '@/core/domain/invoice/numberInutilization/numberInutilization.types';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import ActionIcon from '@/components/_common/ActionIcon';
import { File, Info } from 'react-feather';
import { useInvoiceNumberInutilizationXml } from '@/core/domain/invoiceTransmissionHub/AuxiliaryDocuments/AuxiliaryDocuments.hooks';
import { useReportGenerate } from '@/hooks';

interface Props {
  filter?: NumberInutilizationRequest;
}

export default function DisableNumberTable(props: Props) {
  const numberInutilizationList = useNumberInutilizationList(props.filter);

  const data = flatInfiniteData(numberInutilizationList.data);

  const report = useReportGenerate();

  const invoiceNumberInutilizationXml = useInvoiceNumberInutilizationXml();

  const columns: ColumnsType<NumberInutilization> = [
    {
      dataIndex: 'companyName',
      title: 'Empresa',
      ellipsis: true,
    },
    {
      dataIndex: 'serie',
      title: 'Série',
      ellipsis: true,
    },
    {
      dataIndex: 'startNumber',
      title: 'Numeração inicial',
      ellipsis: true,
    },
    {
      dataIndex: 'endNumber',
      title: 'Numeração final',
      ellipsis: true,
    },
    {
      dataIndex: 'model',
      title: 'Modelo',
      ellipsis: true,
    },
    {
      title: 'Ação',
      align: 'right',
      render: (_, item) => (
        <Group gap={16} position="right">
          <Popover content="Baixar XML">
            <ActionIcon
              disabled={!item.xmlPath}
              onClick={() => downloadXml(item)}
            >
              <File size={16} />
            </ActionIcon>
          </Popover>

          <Popover content="Justificativa">
            <ActionIcon
              disabled={!item.justification}
              onClick={() => viewJustification(item.justification)}
            >
              <Info size={16} />
            </ActionIcon>
          </Popover>
        </Group>
      ),
    },
  ];

  const viewJustification = (justification: string) =>
    Modal.confirm({
      title: 'Justificativa',
      content: justification,
      okButtonProps: { style: { display: 'none' } },
      cancelText: 'Fechar',
    });

  const downloadXml = async (item: NumberInutilization) => {
    const res = await invoiceNumberInutilizationXml.mutateAsync(item.id);
    report.downloadFile({
      result: res,
      fileName: `${item.companyName}_${item.serie}_${item.inutilizationDate}.xml`,
      type: 'application/xml',
    });
  };

  return (
    <Table<NumberInutilization>
      columns={columns}
      dataSource={data}
      pagination={false}
      rowKey={(row) => row.id}
      scroll={{ x: true }}
    />
  );
}
